import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {AuthenticationService} from '../../shared/services/authentication.service';
import {ModalService} from '../../shared/services/modal.service';
import {catchError} from 'rxjs/operators';
import {empty} from '../../functions';
import {studentprofilePlaceholder} from '../../model/model.studentprofile';
import {UserService} from '../../shared/services/user.service';
import {ModelUser} from '../../model/model.user';
import {ModalAccountAvatarComponent} from '../../account/modal-account-avatar/modal-account-avatar.component';
import {faEdit} from '@fortawesome/free-solid-svg-icons';
import {passwordResetUrl} from '../../auth.config';
import {alertMessages, AlertService} from '../../shared/services/alert.service';

@Component({
    selector: 'app-company-account',
    templateUrl: './company-account.component.html',
    styleUrls: ['./company-account.component.scss'],
    standalone: false
})
export class CompanyAccountComponent implements OnInit {

  private readonly destroyRef = inject(DestroyRef);

  faEdit = faEdit;

  avatarPlaceholder = studentprofilePlaceholder.avatarPlaceholder;

  public passwordResetUrl = passwordResetUrl;

  entity: ModelUser = {
    id: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    avatarUri: '',
    allowEmailNotifications: false,
    isSubscribedToNewsletter: false,
    preferredLanguage: '',
    hasAcceptedGdprPolicy: false,
    roles: []
  }

  /**
   * Constructor
   *
   * @param authService
   * @param userService
   * @param modal
   */
  constructor(private authService: AuthenticationService,
              private alertService: AlertService,
              private userService: UserService,
              public modal: ModalService) { }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.loadAccount();

  }

  /**
   * Load account
   */
  loadAccount() {

    this.userService.apiGetAccountCurrent().pipe(catchError(this.userService.handleError('apiGetAccountCurrent', false)), takeUntilDestroyed(this.destroyRef)).subscribe((account) => {

      if (account !== false && !empty(account)) {
        this.entity = Object.assign( {}, <ModelUser>account);


      } else {

      }

    });

  }

  /**
   * Edit the student its avatar / profile image
   */
  editAvatar() {

    this.authService.profile$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( (account) => {

      if (account !==null) {

        const modalOptions = {
          backdrop: 'static',
          size: 'xl'
        };

        const data = Object.assign({}, account);

        this.modal.Modal(ModalAccountAvatarComponent, 'Profile image', '', data, [], modalOptions).then( (result) => {

          if (result === true) {
            this.loadAccount();
          }

        }).catch( (error) => {

        });

      }

    });

  }

  Save() {


    if (empty(this.entity.id)) return;

    this.userService.apiUpdateAccountCurrent(this.entity.id, this.entity).pipe(catchError(this.userService.handleError('apiUpdateAccountCurrent', false)), takeUntilDestroyed(this.destroyRef)).subscribe( (result) => {

      if (result !== false) {
        this.alertService.success(alertMessages.successDataSaved);
      }

    });

  }

}
